import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2';
import { createStream, createPostStream } from '../../actions/StreamActions';
import MiniPlayer  from './IvsPlayer';
import { CONTROLS, POSITION } from './IvsPlayer';

const CreateStream = () => {
    const dispatch = useDispatch();
    const streamObjto = useSelector(state => state.stream)
    const { post, streamKey, playbackUrl } = useSelector(state => state.stream)
    const [origen, setOrigen] = useState("camera")
    const [streamObj, setStreamObj] = useState(null)
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000
    })
    useEffect(() => {
        dispatch(createStream())
    }, [])

    return (
        <div>
            <pre>
                {JSON.stringify(streamObjto, null, 4)}
            </pre>
            <h2>Selecciona origen el video</h2>
            <div onClick={() => setOrigen("camera")}>Camara</div>
            <div onClick={() => setOrigen("software")}>Software de trasmision</div>
            {
                origen === "camera" && <></>
            }
            {
                origen === "software" && <>
                    Clave de transmisión: {streamKey && <input readOnly value={streamKey} />} <button onClick={() => {
                        navigator.clipboard.writeText(streamKey)
                            .then(() => {
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Clave copiada'
                                })
                            })
                            .catch(err => {
                                console.log();
                            });

                    }}>Copiar</button><br />
                    Server de transmisión:
                    <input readOnly value={"rtmps://2702b6cabedc.global-contribute.live-video.net:443/app/"} /> <button onClick={() => {
                        navigator.clipboard.writeText("rtmps://2702b6cabedc.global-contribute.live-video.net:443/app/")
                            .then(() => {
                                Toast.fire({
                                    icon: 'success',
                                    title: 'Server copiado'
                                })
                            })
                            .catch(err => {
                                console.log();
                            });

                    }}>Copiar</button><br />
                    <div style={{
                        width: "30%"
                    }}>
                        {
                           // playbackUrl && <VideoStream playbackUrl={playbackUrl} />
                        }


                        <MiniPlayer
                            streamUrl={playbackUrl}
                            controls={[CONTROLS.resize, CONTROLS.close, CONTROLS.mute]}
                            position={POSITION.bottomRight}
                            transition
                        />

                        

                    </div>
                </>
            }
            <div style={{

            }}>
                {
                    post === null && <button onClick={() => {
                        dispatch(createPostStream({
                            typePost: 2,
                            multimedia: {
                                type: "video/hls",
                                url: {
                                    origin: playbackUrl
                                }
                            }
                        }))
                    }}>Trasmitir</button>
                }


                {/* <div style={{
                width: "30%"
            }}>
                {
                playbackUrl && <S4 playbackUrl={playbackUrl}/>
                }
                
            </div>
           
            <div style={{
                width: "30%"
            }}>
                {
                playbackUrl && <S2 playbackUrl={playbackUrl}/>
                }
                
            </div> */}

            </div>
        </div>
    )
}

export default CreateStream
